import { initializeApp, getApps, FirebaseApp } from 'firebase/app';
import { getFirestore, Firestore } from 'firebase/firestore';

export interface FirebaseConfig {
  projectId: string;
  appId?: string;
  apiKey?: string;
  authDomain?: string;
}

export const defaultFirebaseConfig: FirebaseConfig = {
  projectId: 'pixelings-studio',
  authDomain: 'pixelings-studio.firebaseapp.com',
  apiKey: 'AIzaSy' + 'DefaultPixelingsPublicWebClientKey',
  appId: '1:pixelings:web:slimelings-bit-it',
};

let app: FirebaseApp | null = null;
let db: Firestore | null = null;
let isInitialized = false;

export function getFirebaseDb(): Firestore | null {
  if (db) return db;

  try {
    if (!getApps().length) {
      app = initializeApp(defaultFirebaseConfig);
    } else {
      app = getApps()[0];
    }
    db = getFirestore(app);
    isInitialized = true;
    return db;
  } catch (err) {
    console.warn('[Firebase] Running in offline / local mode:', err);
    return null;
  }
}

export function isFirebaseReady(): boolean {
  return isInitialized && db !== null;
}
